// src/pages/About.js
import React, { useState } from "react";
import "./About.css";
import AboutPopUp from "../AboutPopUp";

function About() {
  const [popupData, setPopupData] = useState(null);

  const processData = [
    {
      id: 1,
      title: "Car Accidents",
      content:
        "If you were injured in a crash, we help you pursue compensation for medical bills, lost income, and pain and suffering. We handle communications with the insurance company, gather key documentation, and build a clear claim strategy so you can focus on recovery.",
      videoIndex: 1,
    },
    {
      id: 2,
      title: "Motorcycle Accidents",
      content:
        "Motorcycle injuries are often serious and riders can face unfair blame. We work to preserve evidence, document injuries, and present the facts clearly—pursuing the coverage available and advocating for a fair outcome.",
      videoIndex: 2,
    },
    {
      id: 3,
      title: "Slip & Falls",
      content:
        "Property owners have a duty to keep premises reasonably safe. If dangerous conditions caused your fall, we investigate quickly, preserve evidence, and work to connect the hazard to your injuries and damages.",
      videoIndex: 3,
    },
    {
      id: 4,
      title: "Rideshare (Uber / Lyft)",
      content:
        "Rideshare claims can involve multiple insurance policies and parties. Whether you were a passenger, driver, or struck by a rideshare vehicle, we help identify coverage, clarify responsibility, and pursue the right parties.",
      videoIndex: 4,
    },
  ];

  const openPopup = (item) => setPopupData(item);
  const closePopup = () => setPopupData(null);

  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About the Attorney</h1>
        <p>
          <strong>Edgar Lopez Law</strong> is a personal injury law office focused
          on representing accident and injury victims. We approach every case
          with clarity, preparation, and client-first advocacy—so you can make
          informed decisions throughout the process.
        </p>

        <h2>Our Practice Focus</h2>
        <p>
          Our practice focuses on a select set of personal injury matters. Tap
          any practice area below to learn more about what these cases involve
          and how we approach them.
        </p>
        <ul className="process-list">
          {processData.map((item) => (
            <li key={item.id} onClick={() => openPopup(item)}>
              <strong>{item.title}:</strong> {item.content.substring(0, 80)}...
            </li>
          ))}
        </ul>

        <h2>Our Commitment</h2>
        <p>
          We believe injury clients deserve straightforward guidance and strong
          advocacy. Our commitment is to communicate clearly, move cases forward
          with purpose, and pursue the best possible outcome under the facts of
          each case. <strong>Se habla español.</strong>
        </p>
      </div>

      {popupData && (
        <AboutPopUp
          onClose={closePopup}
          title={popupData.title}
          content={popupData.content}
          videoIndex={popupData.videoIndex}
        />
      )}
    </div>
  );
}

export default About;